import Vue from 'vue'
import VueRouter from 'vue-router'
import createStore from '../store'
import reportMixin from '@/mixin/reportMixin.js'

// 全局混入reportMixin，使所有组件都具有页面浏览上报功能
Vue.mixin(reportMixin)
const store = createStore()

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
const domainConfig = store ? store.state.domainConfig : {}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */
const processTitle = (title) => {
	if (!title || !domainConfig) return title
	if (title) {
		return domainConfig[title]
	}
}
let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
	},
	{
		path: '/movies',
		name: 'movies',
		component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
	},
	{
		path: '/movies/popular-movies',
		name: 'popularMovies',
		component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
		props: { ranks: 'popular' },
	},
	{
		path: '/movies/now-playing-movies',
		name: 'nowPlayingMovies',
		component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
		props: { ranks: 'now-playing' },
	},
	{
		path: '/movies/top-rated-movies',
		name: 'topRatedMovies',
		component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
		props: { ranks: 'top-rated' },
	},
	{
		path: '/movies/:movieId-:movieName',
		name: 'movieDetail',
		component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
	},
	{
		path: '/tv-shows',
		name: 'tv-shows',
		component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
		meta: {
			title: processTitle('tvTitle'),
			description: 'Stream and download all your favorite TV shows and series in HD for free on {{siteName}}, including titles featuring Sabrina Carpenter, Sydney Sweeney, Blake Lively, and Ella Purnell.',
			keywords: 'TV Shows,Latest TV Series',
		},
	},
	{
		path: '/tv-shows/popular-tv-shows',
		name: 'popularTVShows',
		component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
		props: { ranks: 'popular' },
		meta: {
			title: processTitle('tvPopularTitle'),
			description: 'Explore the most popular TV shows of all time, including iconic reality hits and classic favorites TV shows from the 80s and 90s. Stream legendary series online in HD on Netflix, HBO, Amazon, and {{siteName}}',
			keywords: 'Most Popular TV Shows ',
		},
	},
	{
		path: '/tv-shows/now-playing-tv-shows',
		name: 'nowPlayingTVShows',
		component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
		props: { ranks: 'now-playing' },
		meta: {
			title: processTitle('tvPlayingTitle'),
			description: 'Stream the latest TV shows playing now with new episodes available online on {{siteName}}. Watch current seasons from popular platforms like Netflix, HBO, and Amazon anytime in HD. Stay updated and enjoy your favorite series streaming legally and safely.',
			keywords: 'TV Shows Playing Now',
		},
	},
	{
		path: '/tv-shows/top-rated-tv-shows',
		name: 'topRatedTVShows',
		component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
		props: { ranks: 'top-rated' },
		meta: {
			title: processTitle('tvRatedTitle'),
			description: 'Discover the top IMDb rated TV shows and highest-rated movies streaming now in HD. Watch critically acclaimed series and blockbuster films from Netflix, Amazon, HBO, and more. on {{siteName}}',
			keywords: 'Top Rated TV Shows ',
		},
	},
	{
		path: '/tv-shows/:movieId-:movieName',
		name: 'tvDetail',
		component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
	},

	{
		path: '/movies/:genre/:id/',
		name: 'moviesGenre',
		component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
		props: true,
	},

	{
		path: '/tv-shows/:ranks',
		name: 'tvshowsRanks',
		component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
		props: true,
		meta: {
			title: '{{ranks}} TV Shows | {{siteName}}',
			description: 'Watch the best {{ranks}} TV shows on {{siteName}}. Stream top series and episodes in high definition for free.',
			keywords: '{{ranks}} tv shows',
		},
	},
	{
		path: '/tv-shows/:genre/:id/',
		name: 'tvshowsGenre',
		component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
		props: true,
		meta: {
			title: processTitle('tvGenreTitle') || 'Best {{genre}} TV Shows to Watch & Download for Free',
			description: 'Stream and download the {{genre}} TV series in HD quality for free,Enjoy high-quality streaming with no subscriptions or hidden fees. ',
			keywords: '{{genre}} TV Series ',
		},
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: () => import(/* webpackChunkName: "about-us" */ '../pages/about-us.vue'),
	},
	{
		path: '/detail',
		name: 'detail',
		component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
	},

	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy-policy.vue'),
	},
	{
		path: '/terms-of-service',
		name: 'terms',
		component: () => import('../pages/terms-of-service.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	{
		path: '/movie-download',
		name: 'movie-download',
		component: () => import(/* webpackChunkName: "download-apk-wrapper" */ '../pages/download-apk-wrapper.vue'),
		meta: {
			title: processTitle('tvGenreTitle'),
			description: 'Stream and download the {{genre}} TV series in HD quality for free,Enjoy high-quality streaming with no subscriptions or hidden fees. ',
			keywords: '{{genre}} TV Series ',
		},
	},

	// {
	// 	path: '/:channel(channel[1-9]\\d?)/detail',
	// 	name: 'detailChannel',
	// 	component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
	// 	props: true,
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)',
	// 	name: 'homechannel',
	// 	component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
	// 	props: true,
	// 	beforeEnter: (to, from, next) => {
	// 		console.log(`Accessing /${to.params.channel}`)
	// 		next()
	// 	},
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)/movies',
	// 	name: 'movieschannel',
	// 	component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
	// 	props: true,
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)/movies/:genre',
	// 	name: 'moviesGenreChannel',
	// 	component: () => import(/* webpackChunkName: "movies" */ '../pages/movies.vue'),
	// 	props: true,
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)/tvs',
	// 	name: 'tvschannel',
	// 	component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
	// 	props: true,
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)/tvs/:genre',
	// 	name: 'tvsGenreChannel',
	// 	component: () => import(/* webpackChunkName: "tvs" */ '../pages/tvs.vue'),
	// 	props: true,
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)/about-us',
	// 	name: 'about-us-channel',
	// 	component: () => import(/* webpackChunkName: "about-us" */ '../pages/about-us.vue'),
	// 	props: true,
	// },
	// {
	// 	path: '/:channel(channel[1-9]\\d?)/movie-download/',
	// 	name: 'download-apk-channel',
	// 	component: () => import(/* webpackChunkName: "download-apk-wrapper" */ '../pages/download-apk-wrapper.vue'),
	// 	props: true,
	// },

	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
